
import React from 'react';
import FormComponent from './commons/forms/FormComponent';
import FieldBox from './commons/forms/FieldBox'
import FieldGroup from './commons/forms/FieldGroup'
import provinceList from "../utils/provinces.json"
import cityList from "../utils/cities.json"
import Title from './commons/forms/Title'
import { getAccademyYear, validateEmail, validateFiscalCode } from '../utils/functions'
import { httpPost } from '../api'
import Info from './commons/forms/Info'
import {ReactComponent as LogoPentagramma} from '../assets/images/logo-pentagramma.svg';
import {ReactComponent as LogoPentagrammaWhite} from '../assets/images/logo-pentagramma-white.svg';
import Icon from './commons/Icon'

const emptyData = {
    id: 0,
    withdrawn: "0",
    first_name: '',
    last_name: '',
    address: '',
    street_number: '',
    postal_code: '',
    city: '',
    province: '',
    email: '',
    birth_country: 'it',
    birth_province: '',
    birth_date: '',
    birth_city: '',
    fiscal_code: '',
    phone: '',
    phone2: '',
    sex: '',
    form_delivered: 'NO',
    role: 'STU',
    date_in: '',
    note: '',
    instrument_1: '',
    office_1: '',
    teacher_1: '',
    instrument_2: '',
    office_2: '',
    teacher_2: '',
    instrument_3: '',
    office_3: '',
    teacher_3: '',
    privacy_policy: false,
    cookie_policy: false
}

const accademyYearSlash = getAccademyYear("/")
const accademyYearDash = getAccademyYear("-")



class RegistrationForm extends FormComponent {
    state = 
    {
        data: {...emptyData},
        instruments: [],
        offices: [],
        teachers: [],
        errors:{},
        screen: "form",
        document_url: '',
        schema: [
            {name: "first_name", type: "text", required: true},
            {name: "last_name", type: "text", required: true},
            {name: "email", type: "email", required: true},
            {name: "fiscal_code", type: "fiscal_code", required: true},
            {name: "phone", type: "text", required: true},
            {name: "phone2", type: "text", required: false},
            {name: "birth_country", type: "text", required: true},
            {name: "birth_province", type: "text", required: true},
            {name: "birth_city", type: "text", required: true},
            {name: "birth_date", type: "date", required: true},
            {name: "province", type: "text", required: true},
            {name: "city", type: "text", required: true},
            {name: "address", type: "text", required: true},
            {name: "street_number", type: "text", required: true},
            {name: "postal_code", type: "text", required: true},
            {name: "instrument_1", type: "number", required: true},
            {name: "office_1", type: "number", required: true},
            {name: "teacher_1", type: "number", required: true},
            {name: "instrument_2", type: "number", required: false},
            {name: "office_2", type: "number", required: false},
            {name: "teacher_2", type: "number", required: false},
            {name: "instrument_3", type: "number", required: false},
            {name: "office_3", type: "number", required: false},
            {name: "teacher_3", type: "number", required: false},
            {name: "privacy_policy", type: "boolean", required: true},
            {name: "cookie_policy", type: "boolean", required: true},
          ],
    }

    componentDidMount = async () => {
        
        let obj = await httpPost("instruments", { })
        const instruments = []
        if(obj !== false){
            const { data } = obj 
            for(let i=0; i<data.length; i+=1)
            {
                const dataItem = data[i]
                const { name, id } = dataItem
                const item = {
                    label: name,
                    value: id
                }
                instruments.push(item)
            }
        }

        obj = await httpPost("offices", { cols:[], pagination: { current_page:1, items_per_page:10000 } })
        const offices = []
        if(obj !== false){
            const { data } = obj 
            for(let i=0; i<data.length; i+=1)
            {
                const dataItem = data[i]
                const { name, id } = dataItem
                const item = {
                    label: name,
                    value: id
                }
                offices.push(item)
            }
        }

        obj = await httpPost("teachers", { cols:[], query: "order by last_name, firstname", pagination: { current_page:1, items_per_page:10000 } })
        const teachers = []
        if(obj !== false){
            const { data } = obj 
            for(let i=0; i<data.length; i+=1)
            {
                const dataItem = data[i]
                const { first_name, last_name, id } = dataItem
                const item = {
                    label: last_name+' '+first_name,
                    value: id
                }
                teachers.push(item)
            }
        }

        this.setState({ instruments, offices, teachers })
    }

    submit = async () => {
        const { data } = this.state

        const errors = this.validate()
        await this.setState({ errors });
        const keys = Object.keys(errors)
        if(keys.length > 0)
        {
            return false
        }

        data.accademyYear = accademyYearDash
        data.accademyYearSlash = accademyYearSlash
        
        let obj = await httpPost("register_student", data)
        if(obj !== false){
            await this.setState({ screen: "info", document_url: obj.document_url });
        }

    }
    
    validate = () => {
        const { data, schema } = this.state;
        let errors = {};
        const keys = Object.keys(data)
        for (let i=0; i<keys.length; i+=1) {
            const item = keys[i]
            let value = data[item]
            let buff = (!value || value === '' || value === undefined);
            let singleSchema = schema.filter(schemaItem => {
                return schemaItem.name === item;
            });
            if(singleSchema && singleSchema.length>0)
            {
                singleSchema = singleSchema[0]
                if(buff === true && singleSchema.required === true){
                    if(!((singleSchema.name === 'birth_city' || singleSchema.name === 'birth_province') && data.birth_country === 'xx')) {
                        errors[item] = "required";
                    }
                } else {
                    switch (singleSchema.type){
                        case "email":
                            if(!validateEmail(value)){
                                errors[item] = "bad";   
                            } 
                            break; 
                        case "number":
                            if(singleSchema.required === true && (!value || value === undefined ||value===0)){
                                errors[item] = true;   
                            } 
                            break; 
                        case "fiscal_code":
                            if(!validateFiscalCode(value)){
                                console.log("Fiscal code errato")
                                errors[item] = "required";   
                            } 
                            break;  
                        case "boolean":
                            console.log("boolean", singleSchema.required , value)
                            if(singleSchema.required === true && (!value || value === undefined || value===false)){
                                errors[item] = "required";   
                            } 
                            break;    
                        default:
                            break;          
                    }
                }
            }
        }
        return errors
    }

    render() {
        const { data, errors, instruments, offices, teachers, screen, document_url } = this.state
        const { birth_province, province, birth_country } = data
        const birthCities = cityList.filter(city => city.province === birth_province)
        const birthCitiesDisabled = birth_province===undefined || birth_province===''
        const cities = cityList.filter(city => city.province === province)
        const citiesDisabled = province===undefined || province===''
        const privacyPolicyDescription = "<div style=\"font-size: 0.8em;\">Autorizzo il <a href=\"https://www.iubenda.com/privacy-policy/24420852\" target=\"_blank\" style=\"text-decoration: underline; color: rgb(29 78 216);\">trattamento dei miei dati personali</a>, ai sensi del D. lgs. 196 del 30 giugno 2003</div>"
        const cookiesDescription = "<div style=\"font-size: 0.8em;\">Ho preso visione della <a href=\"https://il-pentagramma.it/cookie-policy\" target=\"_blank\" style=\"text-decoration: underline; color: rgb(29 78 216);\" >gestione cookies</a> su questo sito</div>"
        const errorKeys = Object.keys(errors)

        const countryList = [{label: "Italia",value: "it"},{label: "Estero",value: "xx"}]

        return (
            <div className="w-full flex flex-col items-center"  translate="no" lang="it">
                <div className="w-full flex flex-col md:flex-row items-center justify-center p-9 font-bold bg-pentagramma">
                    <div className="flex items-center justify-center">
                        <Icon icon="clock" />
                        <div className="me-0 md:me-9 my-2 md:my-0 text-sm md:text-base">Lun - Ven 9.00 - 19.30</div>
                    </div>
                    <div className="flex items-center justify-center">
                        <Icon icon="phone" />
                        <div  className="me-0 md:me-9 my-2 md:my-0 text-sm md:text-base">3382943281 - 3406899516</div>
                    </div>
                    <div className="flex items-center justify-center">
                        <Icon icon="envelope" />
                        <div className="my-2 md:my-0 text-sm md:text-base"><a href="mailto:info@il-pentagramma.it" target="_blank" rel="noreferrer">info@il-pentagramma.it</a></div>
                    </div>
                </div>
                <div className="container mx-auto px-5 pb-10 flex align-center justify-center">
                        
                    {screen === "form" && (
                        <div className="w-full md:w-3/5 lg:w-2/5">
                        
                            <div className="flex flex-col justify-center items-center mt-16 mb-6">
                                {/*<img src={require('../assets/images/logo-pentagramma.svg')} alt="Logo Pentagramma" width="100px"/>*/}
                                <LogoPentagramma className="w-28"/>
                            </div>
                            <div className="flex flex-col justify-center items-center">
                                <div className="mt-10">
                                    <div className="text-md md:text-2xl font-bold text-pentagramma">
                                        DOMANDA DI ISCRIZIONE SCUOLA DI MUSICA
                                    </div>
                                    <div className="text-xl md:text-3xl italic font-bold text-pentagramma">
                                        IL PENTAGRAMMA
                                    </div>
                                </div>
                            </div>
                            <div className="flex align-center justify-center md:mt-5 mb-20">
                                <div className="w-full">
                                
                                    <Title text="IL/LA SOTTOSCRITTO/A (ALLIEVO/A) " />
                                    <FieldBox>{ this.renderInput("first_name", "Nome", "text", "...") } </FieldBox>
                                    <FieldBox>{ this.renderInput("last_name", "Cognome", "text", "...") } </FieldBox>
                                    <FieldGroup label="NATO IN">
                                        <FieldBox>{ this.renderSelect("birth_country", "Paese", countryList, false) } </FieldBox>
                                        {birth_country === 'it' && (
                                            <>
                                                <FieldBox>{ this.renderSelect("birth_province", "Provincia", provinceList, false) } </FieldBox>
                                                <FieldBox>{ this.renderSelect("birth_city", "Comune", birthCities, birthCitiesDisabled) } </FieldBox>
                                            </>
                                        )}
                                        <FieldBox>{ this.renderInput("birth_date", "Data di nascita", "date", "...") } </FieldBox>
                                    </FieldGroup>
                                    <FieldBox>{ this.renderInput("fiscal_code", "Codice Fiscale", "text", "...") } </FieldBox>
                                    <FieldGroup label="RESIDENTE IN">
                                        <FieldBox>{ this.renderSelect("province", "Provincia", provinceList, false) } </FieldBox>
                                        <FieldBox>{ this.renderSelect("city", "Comune", cities, citiesDisabled) } </FieldBox>
                                        <FieldBox>{ this.renderInput("address", "Indirizzo", "text", "...") } </FieldBox>
                                        <FieldBox>{ this.renderInput("street_number", "Civico", "text", "...") } </FieldBox>
                                        <FieldBox>{ this.renderInput("postal_code", "C.A.P.", "text", "...") } </FieldBox>
                                    </FieldGroup>
                                    <FieldBox>{ this.renderInput("phone", "Telefono 1", "text", "...") } </FieldBox>
                                    <FieldBox>{ this.renderInput("phone2", "Telefono 2", "text", "...") } </FieldBox>
                                    <FieldBox>{ this.renderInput("email", "Email", "text", "...") } </FieldBox>
                                    <Title text={"CHIEDE L’ISCRIZIONE PER L’ANNO ACCADEMICO "+accademyYearSlash+" AL SEGUENTE CORSO (E' possibile scegliere più di un corso)"} />
                                    <FieldGroup label="#1">
                                        <FieldBox>{ this.renderSelect("instrument_1", "Strumento", instruments, false) } </FieldBox>
                                        <FieldBox>{ this.renderSelect("office_1", "Sede", offices, false) } </FieldBox>
                                        <FieldBox>{ this.renderSelect("teacher_1", "Maestro", teachers, false) } </FieldBox>
                                    </FieldGroup>
                                    <FieldGroup label="#2">
                                        <FieldBox>{ this.renderSelect("instrument_2", "Strumento", instruments, false) } </FieldBox>
                                        <FieldBox>{ this.renderSelect("office_2", "Sede", offices, false) } </FieldBox>
                                        <FieldBox>{ this.renderSelect("teacher_2", "Maestro", teachers, false) } </FieldBox>
                                    </FieldGroup>
                                    <FieldGroup label="#3">
                                        <FieldBox>{ this.renderSelect("instrument_3", "Strumento", instruments, false) } </FieldBox>
                                        <FieldBox>{ this.renderSelect("office_3", "Sede", offices, false) } </FieldBox>
                                        <FieldBox>{ this.renderSelect("teacher_3", "Maestro", teachers, false) } </FieldBox>
                                    </FieldGroup>
                                    <div className="my-10">
                                        <FieldBox>{ this.renderCheckbox("privacy_policy", privacyPolicyDescription) } </FieldBox>
                                        <FieldBox>{ this.renderCheckbox("cookie_policy", cookiesDescription) } </FieldBox>
                                    </div>
                                    <FieldGroup label="Informativa ed istruzioni">
                                        <Info text={"* Inviando il presente modulo il sottoscritto accetta l’iscrizione alla Newsletter mensile della Scuola Il Pentagramma che verrà recapitata all’indirizzo email indicato."} />
                                        <Info text={"* Il sottoscritto dichiara di aver letto ed accettato integralmente il <a style=\"color:#0000ff;text-decoration: underline;\" href=\"https://il-pentagramma.it/\" target=\"_blank\">regolamento</a> dei corsi e di impegnarsi a conservarlo e a rispettarlo."} />
                                        <Info text={"* Attenzione! Una volta inviato il modulo ti verrà data conferma a schermo e tramite email automatica dove troverai un link dal quale scaricare la versione cartacea del modulo da firmare e consegnare all'insegnante"} />
                                    </FieldGroup>
                                    { errorKeys.length>0 && (
                                        <div className="text-red-500 font-bold text-sm ml-2 mt-1">
                                            Attenzione! Alcuni campi inseriti non sono corretti, prego provvedere!
                                        </div>
                                    ) }
                                    <FieldBox>{ this.renderSubmit("Conferma invio modulo") } </FieldBox>
                                    
                                </div>
                            </div>
                        </div>
                    )}
                    
                    {screen === "info" && (
                        <div className="w-full md:w-3/5 lg:w-3/5 mb-20">
                            <div className="flex flex-col justify-center items-center mt-20">
                                <LogoPentagramma className="w-28"/>
                            </div>
                            <div className="flex flex-col justify-center items-center">
                                <div className="mt-10 w-full">
                                    <div className="text-md md:text-2xl font-bold text-pentagramma">
                                        ISCRIZIONE AVVENUTA CON SUCCESSO
                                    </div>
                                    <div className="text-start mt-10">
                                        <div className="mt-10">
                                            Ti confermiamo in data odierna di aver ricevuto i tuoi dati d'scrizione alla scuola di musica Il Pentagramma per l'anno accademico <strong>{ accademyYearSlash }</strong>.<br />
                                            A breve riceverai anche un'email di conferma all'indirizzo <strong>{ data.email }</strong>.
                                        </div>
                                        <div className="mt-10">
                                            Ti raccomandiamo di cliccare sul link qui di seguito per scaricare il modulo cartaceo da stampare, firmare e consegnare al tuo docente per completare la procedura.
                                        </div>
                                        <div className="mt-10 underline text-blue-600 hover:text-blue-800 visited:text-purple-600">
                                            <a href={ document_url } target="_blank" rel="noreferrer">
                                                Scarica il modulo iscrizione in formato PDF, firma e consegna al tuo docente
                                            </a>
                                        </div>
                                        <div className="mt-10">
                                            Grazie per averci scelto e buono studio!
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                </div>
                <div className="w-full flex flex-col items-center justify-center p-10 md:p-24 font-bold bg-pentagramma">
                    <div className="container mx-auto flex align-center justify-center">
                        <div className="w-full md:w-3/5 lg:w-3/5">
                            <div className="grid grid-cols-1 md:grid-cols-2 w-full mb-10 md:mb-20">
                                <div className="w-full flex justify-center align-center mb-8 md:mb-0">
                                    <div className="mt-0 md:mt-7">
                                        <LogoPentagrammaWhite className="w-28"/>
                                    </div>
                                </div>
                                <div className="flex flex-col items-start">
                                    <div className="text-lg mb-2">Contatti</div>
                                    <div className="flex items-center my-1 font-normal">
                                        <Icon icon="map-pin" />
                                        <div className="ms-1 text-xs md:text-base">Via Monte Bivera 4/D Mira 30034 VE</div>
                                    </div>
                                    <div className="flex items-center my-1 font-normal text-xs md:text-base">
                                        <Icon icon="envelope" />
                                        <div className="ms-1"><a href="mailto:info@il-pentagramma.it" target="_blank" rel="noreferrer">info@il-pentagramma.it</a></div>
                                    </div>
                                    <div className="flex items-center my-1 font-normal">
                                        <Icon icon="phone" />
                                        <div className="ms-1 text-xs md:text-base">338 2943281 - 340 6899516</div>
                                    </div>
                                </div>
                            </div>
                            <div className="grid grid-cols-1 md:grid-cols-2 text-sm font-normal">
                                <div className="flex flex-row items-start md:items-center justify-center">
                                    <div className="me-2 text-xs md:text-base">&copy; 2023 Il Pentagramma | Powered by </div>
                                    <div>
                                        <a href="https://www.skeinet.com/" className="a-pentagramma" target="_blank" rel="noreferrer">Skeinet</a>
                                    </div>
                                </div>
                                <div className="flex flex-row items-start md:items-center justify-center mt-3 md:mt-0 text-xs md:text-base">
                                    <div>C.F. 90030910278</div>
                                    <div className="mx-1">-</div> 
                                    <a href="https://il-pentagramma.it/cookie-policy/" className="a-pentagramma" target="_blank" rel="noreferrer">
                                        Cookie Policy
                                    </a> 
                                    <div className="mx-1">-</div>
                                    <a href="https://www.iubenda.com/privacy-policy/24420852" className="a-pentagramma" target="_blank" rel="noreferrer">
                                        Privacy Policy
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
 
export default RegistrationForm;